module.exports = __webpack_public_path__ + "img/symbol-1-right.ac3ca550.png";